import { FolderItem } from 'types'
import React from 'react'
import FolderStructure from 'components/Sidebar/FolderStructure/FolderStructure'
import { useCurrentFolder } from 'hooks/useCurrentFolder'
import { useRootFolder } from 'hooks/useRootFolder'
import { useHistory } from 'react-router'
import { useUser } from 'queries/user/useUser'
import { FolderStructureAdapter } from 'components/Sidebar/FolderStructure/services/FolderStructureAdapter'
import { templatesRoutes } from 'constants/routes'

const SidebarFolderTree: React.FC = () => {
  const { currentFolder, setCurrentFolder } = useCurrentFolder('templates')
  const { rootFolder } = useRootFolder('templates')
  const { location } = useHistory()
  const user = useUser()

  const documentCreationActive = location.pathname.startsWith('/dokument')

  const handleFolderClick = (folder: FolderItem) => {
    if (currentFolder.id !== folder.id) setCurrentFolder(folder)
  }

  return (
    <FolderStructure
      rootFolder={FolderStructureAdapter.adaptRootChildrenToUserSubscriptionType(
        rootFolder,
        user?.subscription.type!,
        'templates',
        user?.casusTemplatesEnabled
      )}
      currentFolder={currentFolder}
      handleFolderClick={handleFolderClick}
      type={documentCreationActive ? 'dark' : 'white'}
      baseUrl={templatesRoutes.main}
    />
  )
}

export default SidebarFolderTree
